"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useController = void 0;
const react_1 = __importStar(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const useAnimatedQRCodePlayer_1 = require("./useAnimatedQRCodePlayer");
const useAnimatedQRCodeReader_1 = require("./useAnimatedQRCodeReader");
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
const useController = () => {
    const [visible, setVisible] = react_1.useState(false);
    const [mode, setMode] = react_1.useState('play');
    const [AnimatedQRCodePlayer, { play }] = useAnimatedQRCodePlayer_1.useAnimatedQRCodePlayer();
    const [AnimatedQRCodeReader, { read }] = useAnimatedQRCodeReader_1.useAnimatedQRCodeReader();
    const reset = () => {
        setVisible(false);
        setMode('play');
    };
    const element = (react_1.default.createElement(react_modal_1.default, { isOpen: visible, style: customStyles },
        react_1.default.createElement("div", { style: {
                width: 320,
                boxSizing: 'border-box',
                padding: 16,
                flex: 1,
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            } }, mode === 'read' ? AnimatedQRCodeReader : AnimatedQRCodePlayer)));
    return [
        element,
        {
            play: (data, options) => __awaiter(void 0, void 0, void 0, function* () {
                setVisible(true);
                setMode('play');
                yield play(data, options);
                reset();
                return;
            }),
            read: (options) => __awaiter(void 0, void 0, void 0, function* () {
                setVisible(true);
                setMode('read');
                const result = yield read(options);
                reset();
                return result;
            }),
        },
    ];
};
exports.useController = useController;
//# sourceMappingURL=useController.js.map